var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon__search",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M15.065 8.882a6.682 6.682 0 1 1-13.365 0 6.682 6.682 0 0 1 13.365 0Zm-.677 5.848a8.382 8.382 0 1 1 .947-1.163l5.742 4.78-.96 1.153-5.73-4.77Z",
  clipRule: "evenodd"
})));
export default SvgSearch;